export default __webpack_public_path__ + "static/media/Untitled2.cca1ecf3.png";